/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useDispatch } from "react-redux";
import {
  getBookingsByCartID,
  removeFromCartReduxStore,
} from "../../../actions/admin/booking";
import { checkStripeRefSession } from "../../../actions/stripeAPI";
import { getDetails } from "../../../actions/admin/quotation";
import NewItemCardPaymentSuccess from "../../../components/layout-new-theme/cards/NewItemCardPaymentSuccess";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLoading } from "../../../components/LoadingContext";
import { useTranslation } from "react-i18next";
import { pushEventGTM } from "../../../utils/gtm";
import moment from "moment";
import { CheckRoundedIcon, ArrowRightIcon } from "../../../components/icons";
import { motion, useReducedMotion } from "framer-motion";
import { Reveal, Stagger, StaggerItem, pressable } from "../../../components/motion";
import { getBookingPriceBreakdown } from "../../../utils/discount";

// The green check pops in with a small spring as the heading fades in -- the
// moment the customer learns the payment went through.
const SuccessCheck = () => {
  const shouldReduceMotion = useReducedMotion();
  return (
    <motion.span
      className="tw:inline-flex tw:flex-shrink-0"
      initial={{ scale: shouldReduceMotion ? 1 : 0.3, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={
        shouldReduceMotion
          ? { duration: 0.2 }
          : { type: "spring", stiffness: 380, damping: 18, delay: 0.1 }
      }
    >
      <CheckRoundedIcon size={24} className="flex-shrink-0" />
    </motion.span>
  );
};


const arrow_right_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/arrow_right.svg";
const tlf_logo_quotation = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-quotation.png";

// ─── Helpers (shared with quotation link page) ───────────────────────────────

const getAdditionalGroups = (booking) => {
  if (booking?.additionalItemsGroups?.length > 0) return booking.additionalItemsGroups;
  if (booking?.additionalItemsQuotation?.length > 0) {
    return [{ heading: booking.additionalItemsQuotationHeader || "", items: booking.additionalItemsQuotation }];
  }
  return [];
};

const getAllAdditionalItems = (booking) =>
  getAdditionalGroups(booking).flatMap(g => g.items || []);

const getBookingTypeKey = (bookingType, isAirportTransfer) => {
  switch (bookingType) {
    case "byTheHour": return "byTheHour";
    case "specifiedDestination": return isAirportTransfer ? "airportTransfer" : "specifiedDestination";
    default: return "";
  }
};

const bookingItemsDetailOrder = [
  "charterCost",
  "lateNightFee",
  "discount",
  "tollFee",
  "longDistanceSurcharge",
  "driverAccomodationTotal",
];

// ─── Standalone Items Card ───────────────────────────────────────────────────

const StandaloneItemsCard = ({ quotation, group, jpySuffix, formatMomentDate, t, i18n }) => {
  const labelCls = "tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1";
  const valueCls = "tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0";
  const divider = <hr className="tw:!my-4 tw:!border-gray-100" />;
  const subtotal = (group.items || []).reduce((sum, ai) => sum + Number(ai?.totalPrice || 0), 0);
  const momentLocale = i18n.language?.toLowerCase() === "jp" ? "ja" : "en";
  const formatDate = (dateStr) =>
    dateStr ? moment(dateStr).locale(momentLocale).format(formatMomentDate) : "";

  return (
    <div className="tw:!mx-auto tw:!bg-white tw:!border tw:!border-[#E8E8E8] tw:!rounded-lg tw:!shadow-sm tw:!mb-3">
      <div className="tw:!p-4 tw:md:!p-6">

        {/* ── Header: only shown when group has a heading ── */}
        {group.heading && (
          <>
            <div>
              <p className={labelCls}>{t("Quotation.LinkPage.AdditionalItems")}</p>
              <p className="tw:!text-[15px] tw:!font-[700] tw:!text-[#282828] tw:!m-0">
                {group.heading}
              </p>
            </div>
            {divider}
          </>
        )}

        {/* ── Items ── */}
        {(group.items || []).map((item, idx) => {
          const isLast = idx === (group.items || []).length - 1;
          const serviceDate = formatDate(item?.serviceDate);
          return (
            <Fragment key={idx}>
              {/* Mobile */}
              <div className="tw:md:!hidden">
                {serviceDate && (
                  <div className="tw:!mb-3">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.ServiceDate")}</p>
                    <p className={valueCls}>{serviceDate}</p>
                  </div>
                )}
                <div className="tw:!mb-3">
                  <p className={labelCls}>{t("Quotation.LinkPage.Table.Name")}</p>
                  <p className={valueCls}>{item?.name || "-"}</p>
                </div>
                <div className="tw:!flex tw:!justify-between tw:!gap-2">
                  <div className="tw:!flex-1">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.UnitPrice")}</p>
                    <p className={valueCls}>{`${Number(item?.price || 0).toLocaleString()}${jpySuffix}`}</p>
                  </div>
                  <div className="tw:!flex-1">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.Qty")}</p>
                    <p className={valueCls}>{item?.qty ?? 0}</p>
                  </div>
                  <div className="tw:!flex-1">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.Amount")}</p>
                    <p className={valueCls}>{`${Number(item?.totalPrice || 0).toLocaleString()}${jpySuffix}`}</p>
                  </div>
                </div>
              </div>
              {/* Desktop */}
              <div className="tw:!hidden tw:md:!flex tw:!items-start">
                <div className="tw:!w-full tw:!flex tw:!gap-4">
                  <div className="tw:!w-[18%]">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.ServiceDate")}</p>
                    <p className={valueCls}>{serviceDate || "-"}</p>
                  </div>
                  <div className="tw:!flex-1">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.Name")}</p>
                    <p className={valueCls}>{item?.name || "-"}</p>
                  </div>
                  <div className="tw:!w-[16%]">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.UnitPrice")}</p>
                    <p className={valueCls}>{`${Number(item?.price || 0).toLocaleString()}${jpySuffix}`}</p>
                  </div>
                  <div className="tw:!w-[8%]">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.Qty")}</p>
                    <p className={valueCls}>{item?.qty ?? 0}</p>
                  </div>
                  <div className="tw:!w-[16%]">
                    <p className={labelCls}>{t("Quotation.LinkPage.Table.Amount")}</p>
                    <p className={valueCls}>{`${Number(item?.totalPrice || 0).toLocaleString()}${jpySuffix}`}</p>
                  </div>
                </div>
              </div>
              {!isLast && divider}
            </Fragment>
          );
        })}
      </div>

      {/* ── Footer: Subtotal ── */}
      <div className="tw:!bg-[#F9F9F9] tw:!px-4 tw:md:!px-8 tw:!py-4 tw:!border-t tw:!border-[#E8E8E8] tw:!rounded-b-lg tw:!flex tw:!justify-between tw:!items-center">
        <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[700] tw:!m-0">
          {t("Quotation.LinkPage.Table.Subtotal")}
        </p>
        <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] tw:!m-0">
          {`${subtotal.toLocaleString()}${jpySuffix}`}
        </p>
      </div>
    </div>
  );
};

// ─── Quotation Payment Success ────────────────────────────────────────────────

const QuotationPaymentSuccess = ({ quotationId }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [quotation, setQuotation] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchFailed, setFetchFailed] = useState(false);

  useEffect(() => {
    if (!quotationId) {
      setIsLoading(false);
      setFetchFailed(true);
      return;
    }
    getDetails(quotationId)
      .then((res) => {
        if (res && res.user) {
          setQuotation(res);
        } else {
          setFetchFailed(true);
        }
      })
      .catch(() => setFetchFailed(true))
      .finally(() => setIsLoading(false));
  }, [quotationId]);

  const lang = i18n.language?.toUpperCase() || "EN";
  const formatMomentDate = lang === "JP" ? "YYYY年M月D日" : "MMMM D, YYYY";
  const jpySuffix = lang === "JP" ? "円" : " JPY";

  const total = quotation?.useDiscount
    ? quotation?.discountedTotalAmount
    : quotation?.totalAmount;

  const hasBookings = Array.isArray(quotation?.bookings) && quotation.bookings.length > 0;
  const standaloneGroups = Array.isArray(quotation?.standaloneItemsGroups)
    ? quotation.standaloneItemsGroups
    : [];
  const hasStandaloneItems = standaloneGroups.length > 0;

  return (
    <div className="row mb-5">
      {/* Success header */}
      <Reveal onMount y={16} className="text-start mb-4">
        <div className="d-flex align-items-center gap-2 mb-3">
          <SuccessCheck />

          <span className={`tw:!text-[24px] tw:!font-[600] tw:!text-[#3CAEA3]`}>
            {t("paymentSuccess.quotation.title")}
          </span>
        </div>

        <hr style={{ borderColor: "#E8E8E8" }} />

        <p className="mb-2">{t("paymentSuccess.quotation.desc1")}</p>
        <p className="mb-0">{t("paymentSuccess.quotation.desc2")}</p>
      </Reveal>

      {/* Loading */}
      {isLoading && (
        <div className="text-center py-5">
          <div className="spinner-border text-secondary" role="status" />
        </div>
      )}

      {/* ── Standalone-only: card list, no quotation page wrapper ── */}
      {!isLoading && !fetchFailed && quotation && !hasBookings && hasStandaloneItems && (
        <div className="mb-4">
          {standaloneGroups.map((group, gIdx) => (
            <StandaloneItemsCard
              key={gIdx}
              quotation={quotation}
              group={group}
              jpySuffix={jpySuffix}
              formatMomentDate={formatMomentDate}
              t={t}
              i18n={i18n}
            />
          ))}
        </div>
      )}

      {/* ── Has bookings: full quotation page ── */}
      {!isLoading && !fetchFailed && quotation && hasBookings && (
        <div className="bg-white rounded mb-4">
          {/* Title bar */}
          <div className="p-3 d-flex align-items-center justify-content-between">
            <h4 style={{ fontSize: "24px", fontWeight: "900", color: "#212529" }} className="m-0">
              {t("Quotation.LinkPage.Quotation")}
            </h4>
            <img src={tlf_logo_quotation} alt="" />
          </div>
          <hr className="m-0 divider" />

          {/* To / From / Meta */}
          <div className="p-3 mb-2">
            <div className="row m-0">
              <div className="col-md-4">
                <p className="m-0 fw-bold fs-12 text-A7A7A7">{t("Quotation.LinkPage.To.English")}</p>
                <p className="m-0 fw-bold fs-16 text-4E4E4E">
                  {quotation.user?.name} {t("Quotation.LinkPage.To.Japanese")}
                </p>
                <p className="text-gold text-decoration-underline mb-1">{quotation.user?.email}</p>
              </div>
              <div className="col-md-5">
                <p className="m-0 fw-bold fs-12 text-A7A7A7">{t("Quotation.LinkPage.From")}</p>
                <p className="m-0 fw-bold fs-16 text-4E4E4E">{t("Quotation.LinkPage.CompanyDetail.Name")}</p>
                <p className="text-gold text-decoration-underline mb-1">{t("Quotation.LinkPage.CompanyDetail.Email")}</p>
              </div>
              <div className="col-md-3">
                <table>
                  <tbody>
                    <tr>
                      <td><p className="p-0 m-0 text-7C7B7B fw-400 fs-14 text-nowrap">{t("Quotation.LinkPage.IssueDate")}</p></td>
                      <td><p className="ms-3 mb-0 text-4E4E4E fw-400 fs-14 text-nowrap">{moment(quotation.issueDate).format(formatMomentDate)}</p></td>
                    </tr>
                    <tr>
                      <td><p className="p-0 m-0 text-7C7B7B fw-400 fs-14 text-nowrap">{t("Quotation.LinkPage.QuotationNumber")}</p></td>
                      <td><p className="ms-3 mb-0 text-4E4E4E fw-400 fs-14 text-nowrap">{quotation.quotationID}</p></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Valid until + total box */}
            <div className="row m-0 mt-3">
              <div className="col-md-4">
                <table className="w-100 border-282828">
                  <tbody>
                    <tr className="border-282828">
                      <td rowSpan={2} className="text-center border-282828">
                        <p className="mb-2 fs-14 fw-400">{t("Quotation.LinkPage.ValidUntil")}</p>
                        <p className="mb-0 fs-14 fw-700 text-282828">
                          {moment(quotation.expiredDate).format(formatMomentDate)}
                        </p>
                      </td>
                      <td className="text-center border-282828 bg-dark">
                        <p className="m-0 text-white fw-700 fs-14">{t("Quotation.LinkPage.Total")}</p>
                      </td>
                    </tr>
                    <tr className="border-282828">
                      <td className="text-center border-282828">
                        <p className="m-0 text-282828 fw-700 fs-20">{`${total?.toLocaleString()}${jpySuffix}`}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* ── Items table ── */}
          <table className="table table-quotation-items mb-3">
            <thead>
              <tr className="bg-dark">
                <th className="align-middle py-2" style={{ width: "2%", whiteSpace: "nowrap" }}>
                  <p className="py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.ServiceDate")}</p>
                </th>
                <th className="align-middle py-2" style={{ width: "10%", whiteSpace: "nowrap" }}>
                  <b className="pb-0 ms-2">{t("Quotation.LinkPage.Table.Name")}</b>
                  <p className="py-0 ms-2 mb-0 text-white">{t("Quotation.LinkPage.Table.Description")}</p>
                </th>
                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                  <p className="py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.UnitPrice")}</p>
                </th>
                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                  <p className="py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.Qty")}</p>
                </th>
                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                  <p className="py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.Amount")}</p>
                </th>
              </tr>
            </thead>
            <tbody>

              {/* ── Bookings ── */}
              {quotation.bookings.map((booking, bIdx) => (
                <Fragment key={`booking-${bIdx}`}>
                  <tr className="bg-7C7B7B">
                    <td colSpan={5}>
                      <p className="m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">
                        {t(`BookingType.${getBookingTypeKey(booking.bookingType, booking.isAirportTransfer)}`)}
                      </p>
                    </td>
                  </tr>

                  {(booking.bookingItems || []).map((b, itemIdx) => (
                    <Fragment key={`item-${bIdx}-${itemIdx}`}>
                      <tr className={itemIdx !== 0 ? "border-top" : ""}>
                        <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!text-[14px]">{lang === "JP" ? b?.serviceDateJP || b?.serviceDate : b?.serviceDate}</p></td>
                        <td>
                          <p className="tw:!text-[#4E4E4E] tw:!font-[700] tw:!text-[14px] tw:!py-0 tw:!mb-0">{lang === "JP" ? b?.nameJP || b?.name : b?.name}</p>
                          <p className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!py-0 tw:!mb-0">{lang === "JP" ? b?.descJP || b?.desc : b?.desc}</p>
                        </td>
                        <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${b?.price?.toLocaleString()}${jpySuffix}`}</td>
                        <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{b?.qty}</td>
                        <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${b?.totalPrice?.toLocaleString()}${jpySuffix}`}</td>
                      </tr>

                      {b.type === "vehicle" && bookingItemsDetailOrder.map((detailKey, i) => {
                        if (detailKey === "discount") {
                          if (!booking.useDiscount) return null;
                          return (
                            <tr key={`disc-${i}`} className="bg-F5F5F5">
                              <td colSpan={4}><p className="px-4 py-0 mb-0 text-description text-end">{`${t("Quotation.LinkPage.Table.Discount")} (${b?.discount}%)`}</p></td>
                              <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[13px]">{b?.totalDiscount ? `-${b.totalDiscount.toLocaleString()}${jpySuffix}` : `0${jpySuffix}`}</td>
                            </tr>
                          );
                        }
                        const detail = b?.details?.find(d => d.id === detailKey);
                        if (!detail || detail.amount <= 0) return null;
                        return (
                          <tr key={`detail-${i}`} className="border-top-dashed">
                            <td /><td><p className="px-4 py-0 mb-0 text-description tw:!text-[#4E4E4E]">{detail.id === "lateNightFee" ? t(`Quotation.LinkPage.Table.${detail.id}`, { hour: detail.nightHours || 0 }) : detail.id ? t(`Quotation.LinkPage.Table.${detail.id}`) : detail.name}</p></td>
                            <td /><td />
                            <td className="text-description tw:!text-[#4E4E4E]">{`${detail.amount?.toLocaleString()}${jpySuffix}`}</td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  ))}

                  {getAdditionalGroups(booking).map((group, gIdx) => (
                    <Fragment key={`add-group-${bIdx}-${gIdx}`}>
                      {group.heading && (
                        <tr className="border-top tw:!bg-[#F1F1F1]">
                          <td colSpan={5}><p className="m-0 py-0 tw:!text-[#212529]">{group.heading}</p></td>
                        </tr>
                      )}
                      {(group.items || []).map((ai, aiIdx) => {
                        const isFirstRow = !group.heading && aiIdx === 0;
                        return (
                          <tr key={`ai-${bIdx}-${gIdx}-${aiIdx}`} className={isFirstRow ? "border-top" : "border-top-dashed"}>
                            <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.serviceDate ? moment(ai.serviceDate).format(formatMomentDate) : ""}</p></td>
                            <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.name || "-"}</p></td>
                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(ai?.price || 0).toLocaleString()}${jpySuffix}`}</td>
                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.qty || ""}</td>
                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(ai?.totalPrice || 0).toLocaleString()}${jpySuffix}`}</td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  ))}

                  <tr className="bg-DADADA">
                    <td colSpan={4}><div className="d-flex justify-content-end align-items-center p-0"><span>{t("Quotation.LinkPage.Table.Subtotal")}</span></div></td>
                    <td>
                      <b className="m-0 p-0 text-nowrap">
                        {`${(
                          (booking.bookingItems || []).reduce((sum, b) => sum + (b.discountedPrice ?? b.totalPrice), 0) +
                          getAllAdditionalItems(booking).reduce((sum, ai) => sum + Number(ai?.totalPrice || 0), 0)
                        ).toLocaleString()}${jpySuffix}`}
                      </b>
                    </td>
                  </tr>

                  {booking?.message?.length > 0 && (
                    <tr className="bg-gold-grey-F9F9F9 border border-bottom">
                      <td className="m-2 d-flex justify-content-start align-items-start">
                        <p className="py-0 px-0 mb-0">{t("Quotation.LinkPage.TransferNotes")}</p>
                      </td>
                      <td colSpan={4}>
                        {booking.message.map((m, mi) => <p key={mi} className="m-0">{m.note}</p>)}
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}

              {/* ── Standalone additional items ── */}
              {hasStandaloneItems && (
                <>
                  <tr className="bg-7C7B7B">
                    <td colSpan={5}>
                      <p className="m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">
                        {t("Quotation.LinkPage.AdditionalItems")}
                      </p>
                    </td>
                  </tr>

                  {standaloneGroups.map((group, gIdx) => (
                    <Fragment key={`standalone-${gIdx}`}>
                      {group.heading && (
                        <tr className="border-top tw:!bg-[#F1F1F1]">
                          <td colSpan={5}><p className="m-0 py-0 tw:!text-[#212529]">{group.heading}</p></td>
                        </tr>
                      )}
                      {(group.items || []).map((ai, aiIdx) => {
                        const isFirstRow = !group.heading && aiIdx === 0;
                        return (
                          <tr key={`standalone-item-${gIdx}-${aiIdx}`} className={isFirstRow ? "border-top" : "border-top-dashed"}>
                            <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.serviceDate ? moment(ai.serviceDate).format(formatMomentDate) : ""}</p></td>
                            <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.name || "-"}</p></td>
                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(ai?.price || 0).toLocaleString()}${jpySuffix}`}</td>
                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{ai?.qty || ""}</td>
                            <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                              <span className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(ai?.totalPrice || 0).toLocaleString()}${jpySuffix}`}</span>
                            </td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  ))}

                  <tr className="bg-DADADA">
                    <td colSpan={4}><div className="d-flex justify-content-end align-items-center p-0"><span>{t("Quotation.LinkPage.Table.Subtotal")}</span></div></td>
                    <td><b className="m-0 p-0 text-nowrap">{`${(quotation.standaloneItemsPrice || 0).toLocaleString()}${jpySuffix}`}</b></td>
                  </tr>
                </>
              )}
            </tbody>
          </table>

          {/* Quotation notes */}
          {quotation.notes && (
            <div className="p-3">
              <p className="noto mx-0 mt-0 mb-1 fw-bold">{t("Quotation.LinkPage.QuotationNotes")}</p>
              <p>{quotation.notes}</p>
            </div>
          )}
        </div>
      )}

      {/* Contact + back */}
      <p className="text-center mb-3">
        {t("paymentSuccess.inquiryMessage.title")}
        <br />{`${t("paymentSuccess.inquiryMessage.link")} info@theluxuryfleet.com`}
        <br />{`${t("paymentSuccess.inquiryMessage.phoneNumber")} 03 6822 8772`}
      </p>
      <div className="d-grid mt-3">
        <button type="button" className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:!rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#FFFFFF] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:rounded tw:py-2" onClick={() => history.push("/")}>
          <div className="tw:flex tw:justify-center tw:py-2 tw:items-center tw:gap-2">
            <div>{t("paymentSuccess.backButton")}</div>
            <ArrowRightIcon color="#FFFFFF" />
          </div>
        </button>
      </div>
    </div>
  );
};

// ─── Standard (booking) Payment Success ───────────────────────────────────────

// Deferred-payment business bookings are not charged per booking — they go on
// the customer's monthly invoice. Read it from the booking's own customer (the
// API populates customer.userId) rather than the login token, so the page is
// right even if it is opened later or by someone else.
const isDeferredPaymentBooking = (booking) => {
  const bookingUser = booking?.customer?.userId;
  return bookingUser?.role === "business" && Boolean(bookingUser?.deferredPaymentEligible);
};

const PaymentSuccess = ({ match, location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [message, setMessage] = useState("PaymentSuccess.AwaitingConfirmationBooking");
  const [successPayment, setSuccessPayment] = useState(false);
  const [booking, setBooking] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isQuotationFallback, setIsQuotationFallback] = useState(false);
  const { showLoading, closeLoading } = useLoading();

  const queryParams = new URLSearchParams(location?.search);
  const isQuotationPayment = queryParams.get("type") === "quotation";
  const stripe_ref = match.params.stripe_ref;

  useEffect(() => {
    // Skip booking flow for known quotation payments
    if (isQuotationPayment) return;

    showLoading(true);
    updateBookingCartItems();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // All bookings in one cart belong to the same customer, so the first one decides.
  const isDeferredPayment = isDeferredPaymentBooking(booking[0]);

  const containerClass = isMobile ? "container-fluid bg-white" : "container-fluid tw:!bg-[#F6F6F6]";

  const updateBookingCartItems = async () => {
    try {
      const stripe_validity_session = await checkStripeRefSession(stripe_ref);

      if (!stripe_validity_session) {
        let bookings;
        try {
          bookings = await getBookingsByCartID(stripe_ref);
        } catch {
          // ID is not a cart/booking — fall through to quotation view
          closeLoading(true);
          setIsQuotationFallback(true);
          return;
        }

        // Empty result also means this is a quotation ID, not a cart
        if (!bookings || bookings.length === 0) {
          closeLoading(true);
          setIsQuotationFallback(true);
          return;
        }

        setBooking(bookings);
        const paymentStatust = bookings[0].paymentStatus;

        if (localStorage.getItem("cart") !== null && bookings[0].withCart) {
          localStorage.removeItem("cart");
          dispatch(removeFromCartReduxStore(null));
          localStorage.removeItem("dtacus");
        }

        if (paymentStatust === "CHARGE_PENDING") {
          setMessage("paymentSuccess.status.recievedBooking");
          setSuccessPayment(true);
          bookings.map((val) => {
            const items = [];
            let totalPrice = 0;
            val.bookingInfo.map((bi, ind) => {
              items.push({
                index: ind,
                item_id: bi.vehicleTypeID._id,
                item_name: bi.vehicleTypeName,
                item_brand: "Toyota",
                affiliation: "Flywire",
                coupon: "",
                discount: 0,
                item_category: val.bookingType === "byTheHour" ? "By The Hour" : val.isAirportTransfer ? "Airport Transfer" : "Specified Destination",
                item_category2: val.destinations.length === 1 ? val.destinations[0].place_id : val.destinations[val.destinations.length - 1].place_id,
                item_category3: (bi.childSeat[0].childSeatCount + bi.childSeat[1].childSeatCount + bi.childSeat[2].childSeatCount) > 0 ? "Child Seats" : "",
                location_id: "",
                price: bi.total,
                quantity: 1,
              });
            });
            // Report the amount actually charged, discount included.
            totalPrice = getBookingPriceBreakdown(val).totalPrice;
            pushEventGTM({ event: "purchase", ecommerce: { currency: "JPY", transcaction_id: val._id, value: totalPrice, items } });
          });
        }
      } else {
        const arrCartId = stripe_validity_session.client_reference_id.split("-");
        if (arrCartId[0] === "CB") {
          const bookings = await getBookingsByCartID(arrCartId[1]);
          setBooking(bookings);
          const paymentStatust = bookings[0].paymentStatus;

          if (stripe_validity_session.status === "complete") {
            setMessage("paymentSuccess.status.recievedBooking");
            setSuccessPayment(true);
            bookings.map((val) => {
              const items = [];
              let totalPrice = 0;
              val.bookingInfo.map((bi, ind) => {
                items.push({
                  index: ind,
                  item_id: bi.vehicleTypeID._id,
                  item_name: bi.vehicleTypeName,
                  item_brand: "Toyota",
                  affiliation: "Flywire",
                  coupon: "",
                  discount: 0,
                  item_category: val.bookingType === "byTheHour" ? "By The Hour" : val.isAirportTransfer ? "Airport Transfer" : "Specified Destination",
                  item_category2: val.destinations.length === 1 ? val.destinations[0].place_id : val.destinations[val.destinations.length - 1].place_id,
                  item_category3: (bi.childSeat[0].childSeatCount + bi.childSeat[1].childSeatCount + bi.childSeat[2].childSeatCount) > 0 ? "Child Seats" : "",
                  location_id: "",
                  price: bi.total,
                  quantity: 1,
                });
              });
              // Report the amount actually charged, discount included.
              totalPrice = getBookingPriceBreakdown(val).totalPrice;
              pushEventGTM({ event: "purchase", ecommerce: { currency: "JPY", transcaction_id: val._id, value: totalPrice, items } });
            });

            if (localStorage.getItem("cart") !== null && bookings[0].withCart) {
              localStorage.removeItem("cart");
              dispatch(removeFromCartReduxStore(null));
              localStorage.removeItem("dtacus");
            }
          }

          if (paymentStatust === "paid") {
            setMessage("paymentSuccess.status.recievedBooking");
            setSuccessPayment(true);
          }
        }
      }

      closeLoading(true);
    } catch (error) {
      closeLoading(true);
      // Last-resort fallback: treat as quotation
      setIsQuotationFallback(true);
      console.error(error);
    }
  };

  // Show quotation view when explicitly flagged or auto-detected
  if (isQuotationPayment || isQuotationFallback) {
    return (
      <FrontLayout>
        <div className={containerClass}>
          <div className="custom-mx">
            <div className="container pb-5 pb-md-0 col-lg-12">
              <div className="row pb-5 d-flex justify-content-lg-center">
                <div className="col-12 col-md-10 px-0 px-md-5 pt-4 pt-md-5 pb-5">
                  <QuotationPaymentSuccess quotationId={stripe_ref} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </FrontLayout>
    );
  }

  return (
    <FrontLayout>
      <div className={containerClass}>
        <div className="custom-mx">
          <div className="container pb-5 pb-md-0 col-lg-12">
            <div className="row pb-5 d-flex justify-content-lg-center">
              <div className="col-12 col-md-10 px-0 px-md-5 pt-4 pt-md-5 pb-5">
                <div className="row mb-5">
                  <Reveal onMount y={16} className="text-start mb-4">
                    <div className="d-flex align-items-center gap-2 mb-3">
                      {successPayment && <SuccessCheck />}

                      <span className={`tw:!text-[24px] tw:!font-[600] ${successPayment ? "tw:!text-[#3CAEA3]" : "tw:!text-[#000000]"}`}>
                        {t(message)}
                      </span>
                    </div>

                    <hr style={{ borderColor: "#E8E8E8" }} />

                    {isDeferredPayment ? (
                      <>
                        <p className="mb-2">{t("paymentSuccess.deferredPayment.1")}</p>
                        <p className="mb-0">{t("paymentSuccess.deferredPayment.2")}</p>
                      </>
                    ) : (
                      <>
                        <p className="mb-2">{t("paymentSuccess.desc.1")}</p>
                        <p className="mb-0">{t("paymentSuccess.desc.2")}</p>
                      </>
                    )}
                  </Reveal>

                  {/* Booked trips rise in one after another. */}
                  <Stagger onMount delayChildren={0.25}>
                    {booking.map((dataItem, index) => (
                      <StaggerItem className="mb-3" key={index + 1}>
                        <NewItemCardPaymentSuccess cart={dataItem} />
                      </StaggerItem>
                    ))}
                  </Stagger>

                  <p className="text-center mb-3">
                    {t("paymentSuccess.inquiryMessage.title")}<br />
                    {`${t("paymentSuccess.inquiryMessage.link")} info@theluxuryfleet.com`}<br />
                    {`${t("paymentSuccess.inquiryMessage.phoneNumber")} 03 6822 8772`}
                  </p>
                  <div className=" d-grid mt-3">
                    <motion.button
                      type="button"
                      whileTap={pressable.tap}
                      className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:!rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#FFFFFF] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:rounded tw:py-2"
                      onClick={() => history.push("/")}
                    >
                      <div className="tw:flex tw:justify-center tw:py-2 tw:items-center tw:gap-2">
                        <div>{t("paymentSuccess.backButton")}</div>
                        <ArrowRightIcon color="#FFFFFF" />
                      </div>
                    </motion.button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default PaymentSuccess;
